import Dashboard from "views/Dashboard.js";
import AlumnoDetalle from "views/AlumnoDetalle.js";
import ReporteExamenVirtual from "views/ReporteExamenVirtual.js";
import ReporteAsistencia from "views/ReporteAsistencia.js";
import Alumno from "views/Alumno.js";
import Docente from "views/Docente.js";
import Cursos from "views/Cursos.js";
import MantenimientoAcademico from "views/MantenimientoAcademico.js";
import Examen from "views/Examen.js";
import Noticia from "views/Noticia.js";
import Libro from "views/Libro.js";
import BuzonDudas from "views/BuzonDudas.js";
import FaltasVirtual from "views/FaltasVirtual.js";
import ArchivoExamen from "views/ArchivoExamen.js";
import Horario from "views/Horario.js";
import HorarioAsistencia from "views/HorarioAsistencia.js";
import CrearCarnet from "views/CrearCarnet.js";
import AsistenciaPresencialPage from "views/AsistenciaPresencialPage.js";
import CursoDetalle from "views/CursoDetalle.js";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "tim-icons icon-chart-pie-36",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/asistencia-presencial",
    name: "Asistencia Presencial",
    icon: "tim-icons icon-check-2",
    component: <AsistenciaPresencialPage />,
    layout: "/admin",
  },
  // ── ACADÉMICO ──
  {
    path: "/alumno",
    name: "Alumnos",
    icon: "tim-icons icon-single-02",
    component: <Alumno />,
    layout: "/admin",
    category: "Académico",
  },
  {
    path: "/alumno/:id",
    component: <AlumnoDetalle />,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/docente",
    name: "Docentes",
    icon: "tim-icons icon-badge",
    component: <Docente />,
    layout: "/admin",
  },
  {
    path: "/cursos",
    name: "Cursos",
    icon: "tim-icons icon-book-bookmark",
    component: <Cursos />,
    layout: "/admin",
  },
  {
    path: "/curso-detalle/:id",
    name: "Detalle de Curso",
    component: <CursoDetalle />,
    layout: "/admin",
    hide: true,
  },
  {
    path: "/mantenimiento",
    name: "Mantenimiento",
    icon: "tim-icons icon-settings",
    component: <MantenimientoAcademico />,
    layout: "/admin",
  },
  {
    path: "/examen",
    name: "Exámenes",
    icon: "tim-icons icon-paper",
    component: <Examen />,
    layout: "/admin",
  },
  // ── COMUNICACIÓN ──
  {
    path: "/buzon-dudas",
    name: "Buzón de Dudas",
    icon: "tim-icons icon-chat-33",
    component: <BuzonDudas />,
    layout: "/admin",
    category: "Comunicación",
  },
  {
    path: "/noticia",
    name: "Noticias",
    icon: "tim-icons icon-bell-55",
    component: <Noticia />,
    layout: "/admin",
  },
  {
    path: "/libro",
    name: "Libros y Materiales",
    icon: "tim-icons icon-book-bookmark",
    component: <Libro />,
    layout: "/admin",
  },
  // ── GESTIÓN ──
  {
    path: "/horario",
    name: "Horarios",
    icon: "tim-icons icon-time-alarm",
    layout: "/admin",
    category: "Gestión",
    subRoutes: [
      {
        path: "/general",
        name: "Horarios Generales",
        component: <Horario />,
        layout: "/admin",
      },
      {
        path: "/asistencia",
        name: "Horario de Asistencia",
        component: <HorarioAsistencia />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/crear-carnet",
    name: "Crear Carnet",
    icon: "tim-icons icon-credit-card",
    component: <CrearCarnet />,
    layout: "/admin",
  },
  // ── REPORTES ──
  {
    path: "/reports",
    name: "Reportes",
    icon: "tim-icons icon-clipboard",
    layout: "/admin",
    category: "Reportes",
    subRoutes: [
      {
        path: "/faltas",
        name: "Faltas y Asistencia",
        component: <FaltasVirtual />,
        layout: "/admin",
      },
      {
        path: "/archivo-examen",
        name: "Archivo de Exámenes",
        component: <ArchivoExamen />,
        layout: "/admin",
      },
      // {
      //   path: "/virtual-assistance",
      //   name: "Asistencia Virtual",
      //   component: <ReporteAsistencia />,
      //   layout: "/admin",
      // },
      // {
      //   path: "/virtual-exams",
      //   name: "Exámenes Virtuales",
      //   component: <ReporteExamenVirtual />,
      //   layout: "/admin",
      // },
    ],
  },
];

export default routes;
